
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useWeeklyHours = (psychologistId?: string) => {
  return useQuery({
    queryKey: ['weekly-hours', psychologistId],
    queryFn: async () => {
      if (!psychologistId) return 0;
      
      // Calcular horas semanais diretamente da tabela psychologist_availability
      const { data, error } = await supabase
        .from('psychologist_availability')
        .select('start_time, end_time')
        .eq('psychologist_id', psychologistId)
        .eq('is_recurring', true);
      
      if (error) {
        console.error('Error fetching weekly hours:', error);
        return 0;
      }
      
      if (!data || data.length === 0) return 0;
      
      // Calcular total de minutos
      let totalMinutes = 0;
      data.forEach(slot => {
        const start = new Date(`1970-01-01T${slot.start_time}`);
        const end = new Date(`1970-01-01T${slot.end_time}`);
        const diffMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
        totalMinutes += diffMinutes;
      });
      
      return totalMinutes;
    },
    enabled: !!psychologistId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const formatWeeklyHours = (totalMinutes: number): string => {
  if (totalMinutes === 0) return '0h 0m/semana';
  
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  
  if (hours === 0) {
    return `${minutes}m/semana`;
  } else if (minutes === 0) {
    return `${hours}h/semana`;
  } else {
    return `${hours}h ${minutes}m/semana`;
  }
};
